export default "__VITE_ASSET__DaNk_SVS__"